import { render, staticRenderFns } from "./country-switcher.vue?vue&type=template&id=72500ec2"
import script from "./country-switcher.vue?vue&type=script&lang=js"
export * from "./country-switcher.vue?vue&type=script&lang=js"
import style0 from "./country-switcher.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports